import I18n from 'I18n';
import { searchDecks } from './DocumentsApi';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Checkbox } from 'foundations-components/transitional/components/Checkbox';
import { Button } from 'foundations-components/transitional/components/Button';
import { FormControl } from 'foundations-components/transitional/components/FormControl';
import { FormActions } from 'foundations-components/transitional/components/FormActions';
import { useContext } from 'react';
import { View } from 'foundations-components/components/View';
import { Select } from 'foundations-components/transitional/components/Select';
import { Flex } from 'foundations-components/components/Flex';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import { InfoIcon } from 'foundations-assets/icons/components/InfoIcon';
import { AuthContext } from '../../contexts/AuthContext';
import DocumentBrandProperty from './DocumentBrandProperty';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const DocumentsPopoverForm = ({
  selectedDeckId,
  selectedBrandId,
  requireEmail,
  deckOptions,
  displayText,
  includeLinkPreview,
  toggleLinkPreview,
  allowDownload,
  toggleAllowDownload,
  handleDeckSelect,
  setDocumentsSearchResults,
  toggleRequireEmail,
  handleConfirm,
  handleCancel,
  showIncludeLinkPreview = true
}) => {
  const auth = useContext(AuthContext);
  const isMultiBrandEnabled = Boolean(auth === null || auth === void 0 ? void 0 : auth.user.scopes.includes('business-units-access'));
  return /*#__PURE__*/_jsxs(View, {
    padding: "400",
    as: "div",
    "data-test-id": "documents-popover"
    // Click events within the popover should not bubble up to the parent.
    // This prevents an issue in unit tests where simulated clicks cause
    // the popover to close on its own.
    ,
    onClick: e => e.stopPropagation(),
    children: [/*#__PURE__*/_jsx(FormControl, {
      label: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "hubspot-prosemirror.documents.decksModal.selectDocument"
      }),
      children: /*#__PURE__*/_jsx(Select, {
        "data-test-id": "decks-select",
        placeholder: "",
        searchPlaceholder: I18n.text('hubspot-prosemirror.documents.popover.search.searchPlaceholder'),
        searchable: deckOptions.length > 10,
        onChange: handleDeckSelect,
        loadOptions: (input, callback) => {
          if (!input.length) {
            callback(null, {
              options: deckOptions
            });
            return;
          }
          searchDecks(input).then(({
            results
          }) => {
            const searchDeckOptions = results.map(deck => {
              return {
                text: deck.name,
                value: deck.contentId
              };
            });
            const searchResults = results.reduce((acc, result) => {
              acc[result.contentId] = result;
              return acc;
            }, {});
            setDocumentsSearchResults(searchResults);
            callback(null, {
              options: searchDeckOptions
            });
          }).catch(() => {
            callback(null, {
              options: []
            });
          });
        }
      })
    }), displayText, isMultiBrandEnabled && /*#__PURE__*/_jsx(DocumentBrandProperty, {
      brandId: selectedBrandId
    }), /*#__PURE__*/_jsx(Checkbox, {
      "data-test-id": "require-email",
      checked: requireEmail,
      onChange: toggleRequireEmail,
      marginBlock: "200",
      padding: "0",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "hubspot-prosemirror.documents.decksModal.requireEmail"
      })
    }), /*#__PURE__*/_jsx(Checkbox, {
      "data-test-id": "allow-download",
      checked: allowDownload,
      onChange: toggleAllowDownload,
      marginBlock: "200",
      padding: "0",
      children: /*#__PURE__*/_jsxs(Flex, {
        alignItems: "center",
        gap: "100",
        children: [/*#__PURE__*/_jsx(FormattedMessage, {
          message: "hubspot-prosemirror.documents.decksModal.allowDownload"
        }), /*#__PURE__*/_jsx(Tooltip, {
          title: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "hubspot-prosemirror.documents.decksModal.allowDownloadTooltip"
          }),
          children: /*#__PURE__*/_jsx(InfoIcon, {
            size: "200",
            color: "icon-core-subtle"
          })
        })]
      })
    }), showIncludeLinkPreview && /*#__PURE__*/_jsx(Checkbox, {
      "data-test-id": "include-link-preview",
      checked: includeLinkPreview,
      onChange: toggleLinkPreview,
      marginBlock: "200",
      padding: "0",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "hubspot-prosemirror.documents.decksModal.includeLinkPreview"
      })
    }), /*#__PURE__*/_jsxs(FormActions, {
      children: [/*#__PURE__*/_jsx(Button, {
        use: "primary",
        "data-test-id": "insert-deck",
        size: "small",
        onClick: handleConfirm,
        disabled: !selectedDeckId,
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "hubspot-prosemirror.documents.decksModal.insertButton"
        })
      }), /*#__PURE__*/_jsx(Button, {
        use: "tertiary-light",
        size: "small",
        onClick: handleCancel,
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "hubspot-prosemirror.documents.decksModal.cancelButton"
        })
      })]
    })]
  });
};
export default DocumentsPopoverForm;